export default __webpack_public_path__ + "static/media/mobile-photo-10.ba9161f6.jpg";